import {
  ITeacherAssignmentDetailsItem,
  ITeacherLessonBaseResponse,
  ITeacherLessonStudentsResponse,
} from '@/entities/TeacherAssignment';
import { AssignmentSubmissionStatusEnum } from '@/entities/Assignment';
import { ITeacherAssignmentInfo } from './TeacherAssignmentInfo';

export const normalizeTeacherAssignmentInfoFromDetails = (
  item: ITeacherAssignmentDetailsItem,
): ITeacherAssignmentInfo => ({
  course: {
    title: item.course.title,
  },
  intake: {
    title: item.intake.title,
  },
  group: {
    number: item.group.number,
  },
  totalStudents: item.totalStudents,
  totalCompleted: item.lesson.assignmentInfo.completed,
  module: {
    title: item.module.title,
  },
  lesson: {
    order: item.lesson.order,
    title: item.lesson.title,
    type: item.lesson.type,
    scheduledAt: item.lesson.scheduledAt,
    endDate: item.lesson.endDate,
    assignmentInfo: {
      awaitingReview: item.lesson.assignmentInfo.awaitingReview,
    },
  },
});

export const normalizeTeacherAssignmentInfoFromBase = (
  baseData: ITeacherLessonBaseResponse,
  studentsData: ITeacherLessonStudentsResponse | undefined,
): ITeacherAssignmentInfo => {
  const awaitingReview =
    studentsData?.students.filter(
      (student) =>
        student.submission?.assignmentStatus === AssignmentSubmissionStatusEnum.AwaitingReview,
    ).length || 0;

  const completed =
    studentsData?.students.filter(
      (student) =>
        student.submission?.assignmentStatus === AssignmentSubmissionStatusEnum.Completed,
    ).length || 0;

  return {
    course: {
      title: baseData.course.title,
    },
    intake: {
      title: baseData.intake.title,
    },
    group: {
      number: baseData.group.number,
    },
    totalStudents: studentsData?.students.length || 0,
    totalCompleted: completed,
    module: {
      title: baseData.module.title,
    },
    lesson: {
      order: baseData.lesson.order,
      title: baseData.lesson.title,
      type: baseData.lesson.type,
      scheduledAt: baseData.lesson.scheduledAt,
      endDate: baseData.lesson.endDate,
      assignmentInfo: {
        awaitingReview,
      },
    },
  };
};
